import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { Pencil, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPrecificacaoEditada = (acao: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return acaoLower === 'precificação editada' || acaoLower.includes('precificação editada');
};

const getIconPrecificacaoEditada = (acao: string): { Icon: LucideIcon; color: string } => {
  return { Icon: Pencil, color: 'var(--c8041c7)' };
};

export default function CardPrecificacaoEditada({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  return (
    <CardHistoricoBase
      item={item}
      icon={getIconPrecificacaoEditada(item.acao)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={item} />}
      tituloCustomizado="Serviço Editado"
    />
  );
}

export const precificacaoEditadaConfig = {
  tipo: 'precificacao_editada',
  detectaTipo: detectaPrecificacaoEditada,
  getIcon: getIconPrecificacaoEditada,
  temExpansao: () => true,
  Component: CardPrecificacaoEditada
};
